import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unreleased: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	released: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	archived: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	all: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unreleased: {
		id: 'project-versions.filter.unreleased',
		defaultMessage: 'Unreleased',
		description: 'Label for unreleased versions',
	},
	released: {
		id: 'project-versions.filter.released',
		defaultMessage: 'Released',
		description: 'Label for released versions',
	},
	archived: {
		id: 'project-versions.filter.archived',
		defaultMessage: 'Archived',
		description: 'Label for archived versions',
	},
	all: {
		id: 'project-versions.filter.all',
		defaultMessage: 'All statuses',
		description: '',
	},
});
export default messages;
